import React from "react";
import * as MUI from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ReadOnlyTextField({ data, label }) {
  const { t } = useTranslation();
  return (
    <MUI.FormControl fullWidth>
      {label && <MUI.FormLabel>{t("Description")}</MUI.FormLabel>}
      <MUI.InputBase
        aria-readonly
        value={data || ""}
        fullWidth
        multiline
        rows={10}
        inputProps={{
          readOnly: true, // Make the text field read-only
        }}
        sx={{
          // Ensure the scrollbars appear
          overflow: "auto", // Enable scrollbars if needed
          border: "none", // Remove the border
          "& .MuiInputBase-input": {
            overflow: "auto", // Enable scrollbars if needed
            resize: "none", // Prevent resizing
            userSelect: "none", // Disable text selection
            WebkitUserSelect: "none", // For Safari
            MozUserSelect: "none", // For Firefox
            msUserSelect: "none", // For Internet Explorer/Edge
          },
          "& .MuiFormLabel-root": {
            color: "text.secondary", // Optionally adjust the label color
          },
        }}
      />
    </MUI.FormControl>
  );
}
